import { useState, useCallback } from 'react';
import './carousel.css';
import publicationsJson from '../publications/publications.json';
import { useSwipe } from '../utils/swipeHandler';

const PAPERS_TO_SHOW = 3;
const logo_filepath = require.context("./paperimages/", false);


export default function PapersCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  // Sort publications by date before slicing to get the most recent papers
  const [papers] = useState(
    publicationsJson
      .filter(paper => paper.image) // Only include papers with images
      .sort((a, b) => new Date(b.published) - new Date(a.published)) // Sort by publication date (newest first)
      .slice(0, 20) // Increase from 10 to 20 papers to include more
  );

  const nextSlide = useCallback(() => {
    setCurrentIndex(current => {
      const maxIndex = papers.length - PAPERS_TO_SHOW;
      return current >= maxIndex ? maxIndex : current + 1;
    });
  }, [papers.length]);

  const prevSlide = useCallback(() => {
    setCurrentIndex(current => current <= 0 ? 0 : current - 1);
  }, []);


  const getTag = (paper) => {
    const currentYear = new Date().getFullYear();
    if (new Date(paper.published).getFullYear() === currentYear) {
      return "New Paper";
    }
    if (paper.comments?.includes("Spotlight")) {
      return "Featured";
    }
    return "Research";
  };

  // Add swipe handlers
  const swipeHandlers = useSwipe(nextSlide, prevSlide);

  return (
    <div className="papers-carousel">
      <div className="papers-header">
        <h2>Recent Research</h2>
        <div className="papers-nav-container">
          <button 
            className="papers-nav prev" 
            onClick={prevSlide}
            disabled={currentIndex === 0}
          >
            <svg viewBox="0 0 24 24">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
            </svg>
          </button>
          <button 
            className="papers-nav next" 
            onClick={nextSlide}
            disabled={currentIndex === papers.length - PAPERS_TO_SHOW}
          >
            <svg viewBox="0 0 24 24">
              <path d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"/>
            </svg>
          </button>
        </div>
      </div>
      
      <div 
        className="papers-track" 
        style={{
          transform: `translateX(-${currentIndex * (100 / PAPERS_TO_SHOW)}%)`
        }}
        {...swipeHandlers}
      >
        {papers.map((paper, index) => (
          <a 
            href={paper.pdf}
            target="_blank"
            rel="noreferrer"
            key={index}
            className="paper-card"
            style={{ 
              backgroundImage: `url(${logo_filepath(`./${paper.image}`)})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          >
            <div className="paper-content">
              <span className="paper-tag">{getTag(paper)}</span>
              <h3 className="paper-title">{paper.title}</h3>
              <p className="paper-authors">
                {paper.authors.slice(0, 3).join(', ')}
                {paper.authors.length > 3 ? ', et al.' : ''}
              </p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
} 